import { userHasPermission, userHasRole } from "@accredo/fe-shared/utils/policyUtils.js";

export default {
  viewAny: ({ user }) => {
    return userHasPermission(user, "blog_post.all.read");
  },
  update: ({ user }) => {
    return userHasPermission(user, "blog_post.all.write");
  }
};